import { spacing } from '@chegg-ui/theme'
import styled from 'styled-components'
import { HeadingProps, HeadingStyles } from '@chegg-wt/core/theme/sharedStyled'
import { themeBreakPoints } from '@chegg-wt/core/theme/theme'

export const Wrapper = styled.div.attrs({
  role: 'region',
  'aria-label': 'Form Glossary',
})`
  max-width: 900px;
`

export const Container = styled.div`
  background-color: #f1f4f5; /* this hex value is not chegg theme color */
  margin-bottom: ${spacing.px8};
  font-size: 16px;
  padding: ${spacing.px24} ${spacing.px40};
  @media (max-width: ${({ theme }) => themeBreakPoints.extraSmall(theme)}) {
    padding: ${spacing.px24};
  }
`

export const ListHeader = styled.h3<HeadingProps>`
  &&& {
    ${HeadingStyles};
    font-size: 16px; /* explicit size set due to stylesheet conflict */
  }
`

export const Body = styled.p`
  line-height: 21px;
`

export const QuestionUL = styled.ul`
  margin-bottom: 0;
  padding: 0;
  li {
    margin-left: 30px;
    list-style-type: disc;
  }
`

export const ContentHeading = styled.h2<HeadingProps>`
  &&& {
    ${HeadingStyles};
    text-align: center;
  }
`

export const HeadingContainer = styled.div`
  margin: ${({ theme }) => theme.spacing.md};
  margin-top: ${({ theme }) => theme.spacing.lg};
  margin-bottom: ${({ theme }) => theme.spacing.xs};
`
